import React from 'react'
import { useTranslation } from 'react-i18next'

import IconWrapper from '~/core/ui/IconWrapper'

const SearchFooter = () => {
  const { t } = useTranslation()
  return (
    <div className="flex h-8 items-center rounded-b-lg border-t border-[#EDF0F4] bg-white px-6">
      <div className="flex flex-1 flex-row items-center space-x-1.5">
        <div className="text-xs text-gray-600">{`${t('label:uSearch:navigate')}`}</div>
        <IconWrapper name="ChevronUp" color="#6B7280" size={16} />
        <IconWrapper name="ChevronDown" color="#6B7280" size={16} />
      </div>
      <div className="flex flex-row items-center space-x-1.5">
        <div className="text-xs text-gray-600">{`${t('label:uSearch:open')}`}</div>
        <IconWrapper name="CornerDownLeft" color="#6B7280" size={16} />
      </div>
    </div>
  )
}
export default SearchFooter
